import { assignJob, getFreePopulation, MAX_FISHERS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireFisherAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.fishingHut.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_FISHERS * settlement.buildings.fishingHut.qty;
    if (settlement.jobs.fishers >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'fishers')) return false;
    settlement.production.fishing.progress.push(0);
    return true;
};
